import { createFileRoute } from '@tanstack/react-router';
import { InviteAuthMethod } from '@/pages';

/**
 * Auth method chooser for the creator invite flow.
 */
export const Route = createFileRoute('/_public/invite/auth')({
  component: InviteAuthMethod,
});
